import React, {useEffect, useState} from "react";
import {Box, Stack, Divider, IconButton, useTheme} from "@mui/material";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import moment from "moment";
import {QRCodeSVG} from "qrcode.react";
import PrintIcon from "@mui/icons-material/Print";
import ExpandIcon from "../../../assets/icons/expand.png";
import CustomTooltip from "../../../core/components/ui/CustomTooltip";
import ExpandQRCodeDialog from "./expand-qrcode.dialog";
import PrintableQRCodePage from "./print-qrcode.dialog";
import useDriver from "../../DriverPlugin/hooks/useDriver";
import CustomChipComponent from "../../../core/components/common/custom-chip.component";


const VehicleItemComponent = (props) => {
    const {vehicleListBookingData, bookingVehicle, index} = props;

    const theme = useTheme();

    const {getViewDriver, driverDetails} = useDriver();

    const [openExpand, setOpenExpand] = useState(false);
    const [openPrint, setOpenPrint] = useState(false);
    const [driverDetailsData, setDriverDetailsData] = useState(null);


    useEffect(() => {
        if (bookingVehicle?.driver_uid) {
            const parameters = {
                profile_uid: bookingVehicle?.driver_uid
            }

            getViewDriver(parameters);
        }
    }, [bookingVehicle])

    useEffect(() => {
        if (driverDetails) {
            setDriverDetailsData(driverDetails);
        }
    }, [driverDetails])


    return (
        <>
            <Stack direction={{xs:"column", sm: "column", md: "column", lg: "row"}} spacing={3} justifyContent="space-between" alignItems="flex-start" py={2} flexWrap="wrap"> 
                <Box flex={1} minWidth={250}>
                    <Stack spacing={1}>
                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            <CustomTypography 
                                variant="caption" 
                                text={"Model:"} 
                                customStyles={{
                                    marginBottom: 0, 
                                    fontSize: 16,
                                    minWidth: 130
                                }}
                            />
                            <CustomTypography
                                variant="body1"
                                text={bookingVehicle.vehicleEntity.model_manufacturer}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        </Stack>

                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            <CustomTypography 
                                variant="caption" 
                                text={"Type:"} 
                                customStyles={{
                                    marginBottom: 0, 
                                    fontSize: 16,
                                    minWidth: 130
                                }}
                            />
                            <CustomTypography
                                variant="body1"
                                text={bookingVehicle.vehicleEntity.type}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        </Stack>

                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            <CustomTypography 
                                variant="caption" 
                                text={"Plate Number:"} 
                                customStyles={{
                                    marginBottom: 0, 
                                    fontSize: 16,
                                    minWidth: 130
                                }}
                            />
                            <CustomTypography
                                variant="body1"
                                text={bookingVehicle.vehicleEntity.plate_number}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        </Stack>

                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            <CustomTypography 
                                variant="caption" 
                                text={"Driver:"} 
                                customStyles={{
                                    marginBottom: 0, 
                                    fontSize: 16,
                                    minWidth: 130
                                }}
                            />
                            <CustomTypography
                                variant="body1"
                                text={(driverDetailsData?.user_info[0]?.firstname + " " + (driverDetailsData?.user_info[0]?.middlename || " ") + " " + driverDetailsData?.user_info[0]?.lastname) || "N / A"}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        </Stack>

                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            <CustomTypography 
                                variant="caption" 
                                text={"ID Type:"} 
                                customStyles={{
                                    marginBottom: 0, 
                                    fontSize: 16,
                                    minWidth: 130
                                }}
                            />
                            <CustomTypography
                                variant="body1"
                                text={driverDetailsData?.id_type}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        </Stack>
                    </Stack>
                </Box>


                <Box flex={1} minWidth={250}>
                    <Stack spacing={1}>
                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            <CustomTypography 
                                variant="caption" 
                                text={"Container:"} 
                                customStyles={{
                                    marginBottom: 0, 
                                    fontSize: 16,
                                    minWidth: 130
                                }}
                            />
                            <CustomTypography
                                variant="body1"
                                text={bookingVehicle.containerEntity?.container_number || "N / A"}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        </Stack>

                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            <CustomTypography 
                                variant="caption" 
                                text={"Entry Type:"} 
                                customStyles={{
                                    marginBottom: 0, 
                                    fontSize: 16,
                                    minWidth: 130
                                }}
                            />
                            <CustomChipComponent category="gatePassType"
                                label={(bookingVehicle?.gatePassEntity.pass_type === "Single Entry Pass") ? "Single Entry" 
                                    : 
                                        (bookingVehicle?.gatePassEntity.pass_type === "Multi Entry Pass") ? "Multi Entry"
                                    :
                                        (bookingVehicle?.gatePassEntity.pass_type === "Annual Pass") ? "Annual"
                                    :
                                        (bookingVehicle?.gatePassEntity.pass_type === "Special Entry Pass") ? "Special Entry"
                                    :
                                        bookingVehicle?.gatePassEntity.pass_type
                                }
                            />
                        </Stack>

                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            <CustomTypography 
                                variant="caption" 
                                text={"Gate Pass Validity:"} 
                                customStyles={{
                                    marginBottom: 0, 
                                    fontSize: 16,
                                    minWidth: 130
                                }}
                            />
                            <CustomTypography
                                variant="body1"
                                text={moment(bookingVehicle.gatePassEntity.valid_to).format("MM/DD/YYYY")}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        </Stack>

                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            <CustomTypography 
                                variant="caption" 
                                text={"Actual Gate In:"} 
                                customStyles={{
                                    marginBottom: 0, 
                                    fontSize: 16,
                                    minWidth: 130
                                }}
                            />
                            <CustomTypography
                                variant="body1"
                                text={moment(bookingVehicle.gatePassEntity.valid_from).format("MM/DD/YYYY HH:mm A")}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        </Stack>

                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            <CustomTypography 
                                variant="caption" 
                                text={"Actual Gate Out:"} 
                                customStyles={{
                                    marginBottom: 0, 
                                    fontSize: 16,
                                    minWidth: 130
                                }}
                            />
                            <CustomTypography
                                variant="body1"
                                text={moment(bookingVehicle.gatePassEntity.valid_to).format("MM/DD/YYYY HH:mm A")}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        </Stack>
                    </Stack>
                </Box>

                <Box mt={{xs: 2, md: 0}} alignSelf={{xs: "flex-start", md: "flex-start"}}>
                    <Stack spacing={1}>
                        <Stack direction="column" spacing={0}>
                            <CustomTypography 
                                variant="caption" 
                                text={"QR Code:"} 
                                customStyles={{
                                    marginBottom: 0, 
                                    fontSize: 16,
                                    ml: "-5px"
                                }}
                            />
                            <QRCodeSVG 
                                value={bookingVehicle.gatePassEntity?.online_qr} 
                                style={{width: 120, height: 115, marginLeft: "-5px"}} 
                            />

                            <Box sx={{ml: 2, display: "flex", gap: 1 }}>
                                <CustomTooltip placement="bottom" title={"Print QR Code"}>
                                    <IconButton onClick={(e) => setOpenPrint(true)}>
                                        <PrintIcon fontSize="small" sx={{color: theme.palette.primary.main}} />
                                    </IconButton>
                                </CustomTooltip>
                                <CustomTooltip placement="bottom" title={"Expand QR Code"}>
                                    <IconButton onClick={(e) => setOpenExpand(true)}>
                                        <img alt="" src={ExpandIcon} style={{height: 16, width: 16}} />
                                    </IconButton>
                                </CustomTooltip>
                            </Box>
                        </Stack>
                    </Stack>
                </Box>
            </Stack>

            {index < vehicleListBookingData?.length - 1 && <Divider sx={{my: 2}} />}

            {openExpand &&
                <ExpandQRCodeDialog 
                    open={openExpand}
                    setOpen={setOpenExpand}
                    data={bookingVehicle.gatePassEntity?.online_qr}
                />
            }

            {openPrint &&
                <PrintableQRCodePage
                    open={openPrint}
                    setOpen={setOpenPrint}
                    data={bookingVehicle}
                />
            }
        </>
    )
}

export default VehicleItemComponent
